import {ErrorHandler, NgModule} from '@angular/core';
import {ErrorsHandler} from './errors-handler';

@NgModule({
  providers: [
    // { Commented because logging errors to API is disabled here
    //   provide: ErrorHandler,
    //   useClass: ErrorsHandler,
    // }
  ]
})
export class ErrorsHandleModule { }
